import { UserRolesCell } from "pages/Admin/Users"
import { useMemo } from "react"
import { RoleCell } from ".."

const useUserTableColumns = () => {

    const teamTableColumns = useMemo(() => [
        {
            accessorKey: 'role',
            header: "תפקיד",
            cell: ({ getValue }) => <RoleCell role={getValue()} />
        },
        {
            accessorKey: 'user_data',
            header: "שיוך",
            cell: UserRolesCell
        }
    ], [])

    return teamTableColumns
}

export default useUserTableColumns